import React from "react"
import {
  StyledImpactApproachTitle,
  StyledImpactApproachContent,
} from "../Typography"
import { Container } from "react-grid-system"
import { Fade } from "react-reveal"
import GreyCircle from "../GreyCircle"
import DarkGreyCircle from "../DarkGreyCircle"
import DarkBlueCircle from "../DarkBlueCircle"
import LightBlueCircle from "../LightBlueCircle"
import LightBlueCircleWithText from "../LightBlueCircleWithText"

const DesktopVersion = () => {
  return (
    <>
      <Container fluid xs sm md>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <Fade ssrReveal left>
            <div style={{ flex: "0 1 100%", display: "flex" }}>
              <div style={{ flex: "0 1 50%" }}>
                <StyledImpactApproachTitle style={{ color: "#0F6497" }}>
                  initial screen
                </StyledImpactApproachTitle>
              </div>
            </div>
            <div
              style={{
                flex: "0 1 50%",
                borderBottom: "3px solid #0F6497",
                marginRight: "4.5px",
                marginBottom: "-6px",
              }}
            ></div>
          </Fade>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "stretch",
            }}
          >
            <div
              style={{
                flex: "0 1 50%",
              }}
            >
              <div style={{ display: "flex", height: "100%" }}>
                <div
                  style={{
                    flex: "1 1 auto",
                    marginTop: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    paddingRight: "15px",
                  }}
                >
                  <Fade ssrReveal left>
                    <StyledImpactApproachContent style={{ color: "#0F6497" }}>
                      Screen each opportunity by developing an impact thesis and
                      evaluating the company’s intentionality and commitment to
                      impact.
                    </StyledImpactApproachContent>
                  </Fade>
                  <div style={{ marginBottom: "10px" }}>
                    <Fade ssrReveal left>
                      <StyledImpactApproachTitle style={{ color: "#60686F" }}>
                        portfolio engagement
                      </StyledImpactApproachTitle>
                    </Fade>
                  </div>
                </div>
                <div
                  style={{
                    flex: "0 0 auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: "300px",
                  }}
                >
                  <Fade ssrReveal right>
                    <DarkBlueCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <LightBlueCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <DarkGreyCircle />
                  </Fade>
                </div>
              </div>
            </div>
            <div
              style={{
                flex: "0 1 50%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: "100%",
                  alignItems: "stretch",
                }}
              >
                <div
                  style={{
                    flex: "0 0 auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: "300px",
                    marginLeft: "-9px",
                  }}
                >
                  <Fade ssrReveal right>
                    <DarkBlueCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <LightBlueCircleWithText />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <GreyCircle />
                    <DarkGreyCircle />
                  </Fade>
                </div>
                <div
                  style={{
                    flex: "1 1 auto",
                    height: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "stretch",
                  }}
                >
                  <div
                    style={{
                      flex: "0 1 100%",
                      height: "calc(50% - 1.5px)",
                      display: "flex",
                      alignItems: "flex-end",
                      textAlign: "right",
                    }}
                  >
                    <div
                      style={{
                        display: "block",
                        marginLeft: "30%",
                        paddingRight: "20px",
                        marginBottom: "3px",
                      }}
                    >
                      <Fade ssrReveal right>
                        <StyledImpactApproachTitle style={{ color: "#1E93D1" }}>
                          impact analysis
                        </StyledImpactApproachTitle>
                      </Fade>
                    </div>
                  </div>
                  <Fade ssrReveal right>
                    <div
                      style={{
                        flex: "0 1 100%",
                        height: "3px",
                        backgroundColor: "#1E93D1",
                      }}
                    ></div>
                  </Fade>
                  <div
                    style={{
                      height: "calc(50% - 1.5px)",
                      flex: "0 1 100%",
                    }}
                  >
                    <div style={{ marginLeft: "30%", marginTop: "14px" }}>
                      <Fade ssrReveal right>
                        <StyledImpactApproachContent
                          style={{ color: "#1E93D1" }}
                        >
                          Assess potential impact performance based on
                          multi-dimension weighted framework to ensure
                          investments meet internal impact requirements.
                        </StyledImpactApproachContent>
                      </Fade>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ flex: "0 1 50%" }}>
              <Fade ssrReveal left>
                <div
                  style={{
                    borderBottom: "3px solid #60686F",
                    marginRight: "4.5px",
                    marginTop: "-6px",
                  }}
                ></div>
              </Fade>
              <div style={{ marginTop: "16px" }}>
                <Fade ssrReveal left>
                  <StyledImpactApproachContent style={{ color: "#60686F" }}>
                    Monitor portfolio companies using a set of impact metrics
                    and indicators to report their progress throughout the
                    investment period.
                  </StyledImpactApproachContent>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

export default DesktopVersion
